<template>
  <div class="process-view">
    <div id="process-view-header">
      <SidebarToggleView />
      <span class="display-2" v-if="!process">Neues Verfahren</span>
      <span class="display-2" v-if="process" v-bind:class="{ 'grey--text': process.archived_at }"
        >Verfahren
        <span class="display-2" v-if="process.seq_nr"> Nr. {{ process.seq_nr }}</span>
        <span class="ml-2" v-if="process.archived_at">(archiviert)</span>
      </span>
      <span style="float:right">
        <v-btn
          v-if="process && process.archived_at"
          outlined
          class="v-raised"
          color="warning"
          v-on:click="toggleArchCnfirm()"
        >
          <v-icon>unarchive</v-icon>Dearchivieren
        </v-btn>
        <v-btn
          v-if="process && !process.archived_at"
          outlined
          class="v-raised"
          color="error"
          v-on:click="toggleArchCnfirm()"
        >
          <v-icon>archive</v-icon>Archivieren
        </v-btn>
      </span>
      <span style="float:right" class="mr-2">
        <v-btn outlined class="v-raised" color="primary" v-on:click="onSaveAndNew()" :disabled="did_change">
          Neu
        </v-btn>
      </span>
      <span style="float:right" class="mr-2">
        <v-btn text icon v-on:click="nextProcess()">
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </span>
      <span style="float:right" class="mr-2">
        <v-btn text icon v-on:click="prevProcess()">
          <v-icon>chevron_left</v-icon>
        </v-btn>
      </span>
    </div>
    <div id="process-view-content">
      <div v-if="loading">Lade...</div>
      <div v-else-if="errors.length > 0">Fehler beim Laden</div>
      <div v-else-if="process">
        <span class="headline mr-4">{{ process.text_header }}</span>
        <span v-if="process.updatedAt"
          >Letzte Änderung am {{ process.updatedAt | moment("DD.MM.YYYY") }} um
          {{ process.updatedAt | moment("HH.mm") }} Uhr</span
        >

        <v-container container--fluid>
          <v-subheader>Status</v-subheader>
          <v-row>
            <v-col cols="12" md="3">
              <v-card class="d-flex align-center" outlined height="72">
                <div>
                  <span>
                    <v-icon
                      class="ml-1"
                      style="float:left"
                      :color="
                        process.status == 'DOCUMENTED' || process.status == 'PLANNED' || process.status == 'COMPLETED'
                          ? 'info'
                          : 'grey lighten-2'
                      "
                      >brightness_1</v-icon
                    >
                    <v-icon
                      style="float:left"
                      :color="process.status == 'PLANNED' || process.status == 'COMPLETED' ? 'info' : 'grey lighten-2'"
                      >brightness_1</v-icon
                    >
                    <v-icon
                      class="mr-1"
                      style="float:left"
                      :color="process.status == 'COMPLETED' ? 'info' : 'grey lighten-2'"
                      >brightness_1</v-icon
                    >
                  </span>
                  <span style="float:left" v-if="process.status == 'OPEN'">offen</span>
                  <span style="float:left" v-if="process.status == 'DOCUMENTED'">Vorgang dokumentiert</span>
                  <span style="float:left" v-if="process.status == 'PLANNED'">Maßnahmen spezifiziert</span>
                  <span style="float:left" v-if="process.status == 'COMPLETED'">Maßnahmen erledigt</span>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card class="d-flex align-center" outlined>
                <v-checkbox
                  class="ml-2"
                  color="info"
                  v-model="statusDocumented"
                  label="Vorgang dokumentiert"
                ></v-checkbox>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card class="d-flex align-center" outlined>
                <v-checkbox
                  class="ml-2"
                  color="info"
                  v-model="statusPlanned"
                  label="Maßnahmen spezifiziert"
                ></v-checkbox>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card class="d-flex align-center" outlined>
                <v-checkbox class="ml-2" color="info" v-model="statusCompleted" label="Maßnahmen erledigt"></v-checkbox>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-expansion-panels accordion multiple v-model="panel">
          <v-expansion-panel lazy>
            <v-expansion-panel-header>
              <div class="headline">Zusammenfassung</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container>
                <soda-text-field
                  ref="first_focus"
                  :someModel="process.text_header"
                  @input="(someModel) => (process.text_header = someModel)"
                  :config="process_specs_dic.text_header"
                  v-on:input="did_change = true"
                >
                </soda-text-field>
                <soda-select
                  :config="process_specs_dic.data_category"
                  :someModel="process.data_category"
                  @input="(someModel) => (process.data_category = someModel)"
                  multiple
                  chips
                  v-on:change="did_change = true"
                ></soda-select>
                <v-item-group>
                  <v-container
                    ><v-row>
                      <v-col cols="12" md="4"
                        ><v-item
                          ><v-card class="d-flex align-center" flat
                            ><v-scroll-y-transition>
                              <soda-combobox
                                :someModel="process.dept_resp"
                                @input="(someModel) => (process.dept_resp = someModel)"
                                :config="process_specs_dic.dept_resp"
                                v-on:change="did_change = true"
                              >
                              </soda-combobox> </v-scroll-y-transition></v-card></v-item
                      ></v-col>
                      <v-col cols="12" md="4"
                        ><v-item
                          ><v-card class="d-flex align-center" flat
                            ><v-scroll-y-transition>
                              <soda-combobox
                                :someModel="process.recipient_category"
                                @input="(someModel) => (process.recipient_category = someModel)"
                                :config="process_specs_dic.recipient_category"
                                v-on:change="did_change = true"
                              >
                              </soda-combobox> </v-scroll-y-transition></v-card></v-item
                      ></v-col>
                      <v-col cols="12" md="4"
                        ><v-item
                          ><v-card class="d-flex align-center" flat
                            ><v-scroll-y-transition>
                              <soda-combobox
                                :someModel="process.delete_period"
                                @input="(someModel) => (process.delete_period = someModel)"
                                :config="process_specs_dic.delete_period"
                                v-on:change="did_change = true"
                              >
                              </soda-combobox> </v-scroll-y-transition></v-card></v-item
                      ></v-col>
                      <v-col cols="12" md="4"
                        ><v-item
                          ><v-card class="d-flex align-center" flat
                            ><v-scroll-y-transition>
                              <soda-combobox
                                :someModel="process.damage_scenario"
                                @input="(someModel) => (process.damage_scenario = someModel)"
                                :config="process_specs_dic.damage_scenario"
                                v-on:change="did_change = true"
                              >
                              </soda-combobox> </v-scroll-y-transition></v-card></v-item
                      ></v-col> </v-row
                  ></v-container>
                </v-item-group>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel lazy>
            <v-expansion-panel-header>
              <div class="headline">Bewertung</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container>
                <v-item-group>
                  <v-container
                    ><v-row>
                      <v-col cols="12" md="4"
                        ><v-item
                          ><v-card class="d-flex align-center" flat
                            ><v-scroll-y-transition>
                              <soda-combobox
                                :someModel="process.risk_probability"
                                @input="
                                  (someModel) => {
                                    process.risk_probability = someModel;
                                    on_changed_risk_probability();
                                  }
                                "
                                :config="process_specs_dic.risk_probability"
                              >
                              </soda-combobox> </v-scroll-y-transition></v-card></v-item
                      ></v-col>
                      <v-col cols="12" md="4"
                        ><v-item
                          ><v-card class="d-flex align-center" flat
                            ><v-scroll-y-transition>
                              <soda-combobox
                                :someModel="process.damage_rate"
                                @input="
                                  (someModel) => {
                                    process.damage_rate = someModel;
                                    on_changed_damage_rate();
                                  }
                                "
                                :config="process_specs_dic.damage_rate"
                              >
                              </soda-combobox> </v-scroll-y-transition></v-card></v-item
                      ></v-col>
                      <v-col cols="12" md="4"
                        ><v-item
                          ><v-card class="d-flex align-center" flat
                            ><v-scroll-y-transition>
                              <soda-combobox
                                :someModel="process.victim_risk"
                                @input="
                                  (someModel) => {
                                    this.process.victim_risk = someModel;
                                    on_changed_victim_risk();
                                  }
                                "
                                :config="process_specs_dic.victim_risk"
                              >
                              </soda-combobox> </v-scroll-y-transition></v-card></v-item
                      ></v-col> </v-row
                  ></v-container>
                </v-item-group>

                <soda-text-area
                  :someModel="process.text_problem"
                  @input="(someModel) => (process.text_problem = someModel)"
                  v-on:input="did_change = true"
                  :config="process_specs_dic.text_problem"
                >
                </soda-text-area>
                <soda-select
                  multiple
                  chips
                  :someModel="process.legal_basis"
                  @input="
                    (someModel) => {
                      process.legal_basis = someModel;
                    }
                  "
                  :config="process_specs_dic.legal_basis"
                  v-on:change="did_change = true"
                >
                </soda-select>
                <soda-text-area
                  :someModel="process.text_legal"
                  @input="(someModel) => (process.text_legal = someModel)"
                  :config="process_specs_dic.text_legal"
                  v-on:input="did_change = true"
                >
                </soda-text-area>
                <v-checkbox 
                  v-model="process.assessment_necessary" 
                  color="primary" 
                  label="DSFA notwendig"
                  v-on:change="did_change = true"
                > </v-checkbox>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel lazy>
            <v-expansion-panel-header>
              <div class="headline">Technisch Organisatorische Maßnahmen (TOMs)</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <div class="title">Allgemeine TOMs</div>
                    </span>
                  </template>
                  <span>
                    Allgemeine TOMs betreffen in der Regel mehrere Verfahren.<br />
                    Der hier vermerkte Status der verknüpften allgemeinen TOM spiegelt<br />
                    den Erledigungsstatus der TOM mit Bezuf auf dieses Verfahren wieder.
                  </span>
                </v-tooltip>
                <!-- list of company's measure sets-->
                <template v-for="(item, index) in process.measureSets">
                  <ProcessMeasureSetView
                    :processMeasureSet="item"
                    :companyId="process.processCompanyId"
                    :processTextHeader="process.text_header"
                    v-on:processMeasureSetUpdated="onProcessMeasureSetUpdated"
                    v-on:processMeasureSetDeleted="onProcessMeasureSetDeleted"
                    v-bind:key="index"
                  />
                </template>
                <ProcessMeasureSetCreateView
                  :processMeasureSetOptions="processMeasureSetOptions"
                  :companyId="process.processCompanyId"
                  :processTextHeader="process.text_header"
                  v-on:processMeasureSetCreated="onProcessMeasureSetCreated"
                />
                <ProcessMeasureListView
                  :companyId="process.processCompanyId"
                  :processId="process.id"
                  :processMeasures="process.measures"
                  :assessment_necessary="process.assessment_necessary"
                  v-on:processMeasureCreated="onProcessMeasureCreated"
                  v-on:processMeasureUpdated="onProcessMeasureUpdated"
                  v-on:processMeasureDeleted="onProcessMeasureDeleted"
                />
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div class="mt-12">
          <v-card flat dark class="mt-2">
            <v-list two-line>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    Dieses Verfahren löschen
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Dieses Verfahren dauerhaft und unwiderbringlich löschen.
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn outlined color="error" v-on:click="onShowDeleteProcessDialog()">
                    Löschen
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
          <ProcessDeleteView
            :process_id="process.id"
            :showThis="show_delete_process_dialog"
            v-on:discard="show_delete_process_dialog = false"
            v-on:didDelete="onDeleted()"
          >
          </ProcessDeleteView>
        </div>
      </div>
    </div>

    <!-- Dialog for confirming archive process-->
    <v-dialog v-model="archiveDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Verfahren archivieren</v-card-title>

        <v-card-text>
          Sind Sie sicher, dass Sie dieses Verfahren archivieren möchten?
        </v-card-text>
        <v-card-text>
          Archivierte Verfahren können über die option <i>Archivierte Verfahren anzeigen</i> jederzeit dargestellt und
          bei Bedarf aus dem Archiv wiederhergestellt werden, tauchen jedoch nicht im ausgedruckten
          Verfahrensverzeichnis auf. Die eindeutige Nummer des Verfahrens bleibt erhalten. Die Archivierung ist
          revisionssicher.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" outlined @click.stop="archiveDialog = false">
            Nein
          </v-btn>

          <v-btn color="error" outlined @click.stop="toggleArch()">
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog for confirming unarchive process-->
    <v-dialog v-model="unarchiveDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Verfahren dearchivieren</v-card-title>

        <v-card-text>
          Sind Sie sicher, dass Sie dieses Verfahren aus dem Archiv wiederherstellen möchten?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" outlined @click.stop="unarchiveDialog = false">
            Nein
          </v-btn>

          <v-btn color="warning" outlined @click.stop="toggleArch()">
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ProcessCreateView
      :showThis="show_process_create_view"
      :company_id="company_id"
      :num_procs="processes_sort_order.length"
      :max_procs="max_processes"
      v-on:discard="show_process_create_view = false"
    >
    </ProcessCreateView>
    <AutoChangeDialogView :showThis="auto_changes.length > 0" :changes="auto_changes"> </AutoChangeDialogView>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { listProcessMeasureSetsByProcessId } from "../graphql/queries";

import { updateProcess } from "../graphql/mutations";

import ProcessMeasureListView from "./ProcessMeasureListView";

import SodaSelect from "./lib/inputs/SodaSelect";
import SodaTextField from "./lib/inputs/SodaTextField";
import SodaTextArea from "./lib/inputs/SodaTextArea";
import SodaCombobox from "./lib/inputs/SodaCombobox";
import ProcessCreateView from "./ProcessCreateView";
import ProcessDeleteView from "./ProcessDeleteView";
import ProcessMeasureSetView from "./ProcessMeasureSetView";
import ProcessMeasureSetCreateView from "./ProcessMeasureSetCreateView";
import SidebarToggleView from "./SidebarToggleView";
import AutoChangeDialogView from "./AutoChangeDialogView";
import load_specs from "../specs/specs_parser";
const process_specs = load_specs("process.yml");

import ProcessCalculator from "../util/ProcessCalculator.js";

const plans_specs = require("json-loader!yaml-loader!../specs/plans.yml");
function arrayToObject(arr, key) {
  var rv = {};
  for (var i = 0; i < arr.length; ++i) rv[arr[i][key]] = arr[i];
  return rv;
}
const products = arrayToObject(plans_specs.products, "id");

const listCompanyMeasureSets = `query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      name
      measureSets(limit:20) {
          items {
              id
              type
              label
              description
              commentatory
              seq_nr
              status
              updatedAt
          }
          nextToken
      }
      processes(limit:500) {
          items {
              id
              seq_nr
          }
      }
    }
  }
  `;

const listCompanyProcesses = `query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      processes(limit:500) {
          items {
              id
              seq_nr
              archived_at
          }
      }
    }
  }
  `;

export const getProcess = `query GetProcess($id: ID!) {
    getProcess(id: $id) {
      id
      comments {
        items {
          id
          text
          createdAt
          updatedAt
          archived_at
          # deleted_at
        }
        nextToken
      }
      text_header
      seq_nr
      status
      text_legal
      legal_basis
      text_problem
      damage_scenario
      risk_probability
      data_category
      victim_risk
      damage_rate
      dept_resp
      recipient_category
      delete_period
      assessment_necessary
      measureSets (limit: 20) {
        items {
          id
          status
          measureSet {
            id
            seq_nr
            type
            description
          }
        }
        nextToken
      }
      measures (limit: 100) {
        items {
          id
          auto_managed
          label
          description
          status
          createdAt
          updatedAt
        }
        nextToken
      }
      # tags {
      #   id
      #   label
      # }
      createdAt
      updatedAt
      archived_at
      # deleted_at
    }
  }
  `;

var process_old;

export default {
  name: "ProcessView",
  components: {
    //MeasureList,
    SodaSelect,
    SodaTextField,
    SodaTextArea,
    SodaCombobox,
    ProcessCreateView,
    ProcessDeleteView,
    SidebarToggleView,
    AutoChangeDialogView,
    ProcessMeasureSetView,
    ProcessMeasureSetCreateView,
    ProcessMeasureListView,
  },
  computed: {
    did_change: {
      get() {
        return this.$data._did_change;
      },
      set(value) {
        if (value === true && this.$data.process.text_header !== "") {
          this.$eventHub.emit("sync-status-touched");
          clearTimeout(this.$data._save_timer);
          this.$data._save_timer = setTimeout(() => {
            this.save();
            this.calculator.should_update_status(false);
          }, 1000);
        }
        this.$data._did_change = value;
      },
    },
    process_for_save() {
      var process = { ...this.process };
      process.legal_basis = JSON.stringify(process.legal_basis);
      process.data_category = JSON.stringify(process.data_category);
      process.text_problem = process.text_problem !== "" ? process.text_problem : null;
      process.text_legal = process.text_legal !== "" ? process.text_legal : null;
      process.comments = undefined;
      process.measures = undefined;
      process.measureSets = undefined;
      process.updatedAt = undefined; // will be set by aws appsync
      process.createdAt = undefined; // will be set by aws appsync
      return process;
    },
    getProcessQuery() {
      return this.$Amplify.graphqlOperation(getProcess, { id: this.process.id });
    },
    listMeasureSetsQuery() {
      return this.$Amplify.graphqlOperation(listCompanyMeasureSets, { id: this.company_id });
    },
    listProcessesQuery() {
      return this.$Amplify.graphqlOperation(listCompanyProcesses, { id: this.company_id });
    },
    updateProcessMutation() {
      return this.$Amplify.graphqlOperation(updateProcess, { input: this.process_for_save });
    },
    max_seq_nr: {
      get() {
        return this.$store.state.originalStore.max_seq_nr;
      },
      set(value) {
        this.$store.commit("SET_max_seq_nr", value);
      },
    },
    user_info() {
      return this.$store.state.originalStore.user_info;
    },
    company_id() {
      return this.$route.params.cid;
    },
    max_processes() {
      if (!this.user_info) {
        return null;
      }
      var product_id = this.user_info.attributes["custom:active_product_id"];
      return products[product_id].usage.max_processes;
    },
    statusDocumented: {
      get() {
        return (
          this.process.status === "DOCUMENTED" ||
          this.process.status === "PLANNED" ||
          this.process.status === "COMPLETED"
        );
      },
      set(new_value) {
        this.process.status = new_value ? "DOCUMENTED" : "OPEN";
        this.did_change = true;
      },
    },
    statusPlanned: {
      get() {
        return this.process.status === "PLANNED" || this.process.status === "COMPLETED";
      },
      set(new_value) {
        this.process.status = new_value ? "PLANNED" : "DOCUMENTED";
        this.did_change = true;
      },
    },
    statusCompleted: {
      get() {
        return this.process.status === "COMPLETED";
      },
      set(new_value) {
        this.process.status = new_value ? "COMPLETED" : "PLANNED";
        this.did_change = true;
      },
    },
  },
  mounted() {
    // check if route has been provided with an id
    // if yes fetch from api
    // if no just display with placeholders
    document.t = this;
    this.process_specs = process_specs;
    this.initView(this.company_id, this.$route.params.pid);
  },
  async beforeRouteUpdate(to, from, next) {
    if (this.did_change) {
      clearTimeout(this._save_timer);
      await this.save();
    }
    this.initView(to.params.cid, to.params.pid);
    next();
  },
  methods: {
    //...mapMutations(['set_max_seq_nr']),
    initView(cid, pid) {
      this.process = { id: pid };
      this.load();
      this.panel = [0, 1, 2];
    },
    load() {
      var self = this;
      this.loading = true;
      this.$Amplify.API.graphql(this.getProcessQuery)
        .then((response) => this.onLoaded(response))
        .then(() => {
          self.$Amplify.API.graphql(self.listMeasureSetsQuery).then((response) => {
            self.processMeasureSetOptions = response.data.getCompany.measureSets.items.filter((item) => {
              return self.process.measureSets.map((obj) => obj.measureSet.id).indexOf(item.id) === -1;
            });
            self.processMeasureSetOptions.sort((a, b) => (a.seq_nr > b.seq_nr ? 1 : -1));
          });
          self.$Amplify.API.graphql(self.listProcessesQuery).then((response) => {
            var processes = response.data.getCompany.processes.items;
            processes.sort((a, b) => (a.seq_nr > b.seq_nr ? 1 : -1));
            if (this.process.archived_at === null) {
              processes = processes.filter((e) => e.archived_at === null);
            }
            this.processes_sort_order = processes.map((e) => e.id);
          });
        });
    },
    suggest_change(change) {
      this.auto_changes.push(change);
    },
    finish_change(change_result) {
      this.save();
    },
    on_changed_damage_rate() {
      this.calculator.should_update_victim_risk();
      this.did_change = true;
    },
    on_changed_risk_probability() {
      this.calculator.should_update_victim_risk();
      this.did_change = true;
    },
    on_changed_victim_risk() {
      this.calculator.should_update_victim_risk();
      this.calculator.should_update_assessment_necessary();
    },
    onLoaded(response) {
      this.process = response.data.getProcess;
      this.process.measures = this.process.measures.items || [];
      this.process.measures.sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1));
      this.process.measureSets = this.process.measureSets.items;
      this.process.company = undefined;
      this.process.processCompanyId = this.$route.params.cid;
      this.process.lastDSFA = undefined;
      this.process.comments = undefined;
      this.process.tags = undefined;
      this.process.status = this.process.status || "OPEN";
      this.process.legal_basis = JSON.parse(this.process.legal_basis || "[]");
      this.process.data_category = JSON.parse(this.process.data_category || "[]");
      this.process.text_problem = this.process.text_problem || "";
      this.process.text_legal = this.process.text_legal || "";
      this.calculator = new ProcessCalculator(this.process, this.suggest_change, this.finish_change);
      process_old = this.process_for_save; // save for audit diff
      this.loading = false;
    },
    async save() {
      this.$eventHub.emit("sync-status-syncing");
      return new Promise((resolve, reject) => {
        if (this.can_update_process()) {
          this.$Amplify.API.graphql(this.updateProcessMutation)
            .then((response) => {
              this.onSaved(response);
              resolve();
            })
            .catch((err) => {
              this.$eventHub.emit("sync-status-failure", {
                entity_type: "Verfahren",
                entity_label: this.process.text_header,
                sync_type: "update",
                error: err.errors[0].message,
              });
              reject(err);
            });
        } else {
          var num_processes = this.processes_sort_order.length;
          this.$eventHub.emit("show-process-update-disallowed", num_processes);
          resolve();
        }
      });
    },
    onSaved(response) {
      this.process.updatedAt = response.data.updateProcess.updatedAt;
      this.$eventHub.emit("sync-status-success", {
        entity_type: "Verfahren",
        entity_label: this.process.text_header,
        sync_type: "update",
      });
      let process_new = this.process_for_save;
      this.$recordUpdate(this.process.processCompanyId, "PROCESS", process_old, process_new, (res, err) => {
        res ? console.log("logged PROCESS update", res) : console.error("error logging PROCESS update", err, e);
      });
      process_old = process_new;
      this.did_change = false;
    },
    can_create_process() {
      var num_processes = this.processes_sort_order.length;
      return num_processes < this.max_processes;
    },
    can_update_process() {
      var num_processes = this.processes_sort_order.length;
      return num_processes <= this.max_processes;
    },
    toggleArch() {
      if (this.process.archived_at) {
        this.process.archived_at = null;
      } else {
        this.process.archived_at = new Date().toISOString();
      }
      this.$eventHub.emit("sync-status-syncing");
      this.$Amplify.API.graphql(this.updateProcessMutation)
        .then((response) => {
          this.onSaved(response);
          this.archiveDialog = false;
          this.unarchiveDialog = false;
        })
        .catch((err) => {
          this.$eventHub.emit("sync-status-failure", {
            entity_type: "Verfahren",
            entity_label: this.process.text_header,
            sync_type: "update",
            error: err.errors[0].message,
          });
        });
    },
    toggleArchCnfirm() {
      if (this.process.archived_at) {
        this.unarchiveDialog = true;
      } else {
        this.archiveDialog = true;
      }
    },
    onSaveAndNew() {
      if (this.can_create_process()) {
        this.show_process_create_view = true;
      } else {
        var num_processes = this.processes_sort_order.length;
        this.$eventHub.emit("show-process-create-disallowed", num_processes);
      }
    },
    nextProcess() {
      var len = this.processes_sort_order.length;
      var nextIdIndex = (this.processes_sort_order.indexOf(this.process.id) + 1) % len;
      var nextId = this.processes_sort_order[nextIdIndex];
      this.$router.push({ path: `/app/company/${this.company_id}/process/${nextId}` });
    },
    prevProcess() {
      var len = this.processes_sort_order.length;
      var prevIdIndex = (this.processes_sort_order.indexOf(this.process.id) - 1 + len) % len;
      var prevId = this.processes_sort_order[prevIdIndex];
      this.$router.push({ path: `/app/company/${this.company_id}/process/${prevId}` });
    },
    onProcessMeasureCreated(processMeasure) {
      this.process.measures.push(processMeasure);
      this.$forceUpdate()
      this.calculator.should_update_status(true);
    },
    onProcessMeasureUpdated(resp, index) {
      this.$forceUpdate()
      this.calculator.should_update_status(true);
    },
    onProcessMeasureDeleted(index) {
      this.process.measures.splice(index, 1);
      this.$forceUpdate()
      this.calculator.should_update_status(true);
    },
    onProcessMeasureSetUpdated(index) {
      this.$forceUpdate()
      this.calculator.should_update_status(true);
    },
    onProcessMeasureSetDeleted(processMeasureSet) {
      this.process.measureSets = this.process.measureSets.filter((item) => item.id !== processMeasureSet.id);
      this.processMeasureSetOptions.push(processMeasureSet.measureSet);
      this.processMeasureSetOptions.sort((a, b) => (a.seq_nr > b.seq_nr ? 1 : -1));
      this.$forceUpdate()
      this.calculator.should_update_status(true);
    },
    onProcessMeasureSetCreated(processMeasureSet) {
      var measureSetId = processMeasureSet.measureSet.id;
      this.process.measureSets.push(processMeasureSet);
      this.processMeasureSetOptions = this.processMeasureSetOptions.filter((item) => item.id !== measureSetId);
      this.calculator.should_update_status(true);
    },
    onShowDeleteProcessDialog() {
      this.show_delete_process_dialog = true;
    },
    onDeleted() {
      this.$router.push({ path: `/app/company/${this.company_id}/processes` });
    },
  },
  data: () => ({
    process: null,
    process_specs: null,
    processes_sort_order: [],
    loading: true,
    errors: [],
    _did_change: false,
    process_specs_dic: Object.assign({}, ...process_specs.fields.map((s) => ({ [s.name]: s }))),
    archiveDialog: false,
    unarchiveDialog: false,
    panel: [true, true, true],
    processMeasureSetOptions: [],
    measureSets: [],
    _save_timer: null,
    show_process_create_view: false,
    show_delete_process_dialog: false,
    calculator: null,
    auto_changes: [],
  }),
};
</script>

<style lang="scss" scoped></style>
